import { Expose } from 'class-transformer';
import { DvSnapshotValue } from './snapshot-value.entity';
import { CalloutContent } from '../callout-content.entity';
export class DvSnapshotField {
  @Expose()
  entityReference?: string; //can be something like “personalInfo”, "mySituation"
  @Expose()
  fieldReference?: string; //for reference purposes if we need "firstName"
  @Expose()
  snapshotValue?: DvSnapshotValue;
  @Expose()
  calloutContent?: CalloutContent;
}
